// Values mirror dealroom-fe/.env/.env.{development,beta,production}.
// Beta and prod share the "top-legal-prod" Cognito pool.
const configs = {
    dev: {
        gqlEndpoint: 'https://dev-apollo.top.legal/graphql',
        cognito: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_mDKAYOjHb',
            clientId: '1p28i4r0daocn6lbkjpj0vm81',
            oauthDomain: 'https://top-legal-dev.auth.eu-central-1.amazoncognito.com',
        },
        addinOrigin: 'https://dev-outlook.top.legal',
    },
    beta: {
        gqlEndpoint: 'https://beta-apollo.top.legal/graphql',
        cognito: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_tgXUQvdgQ',
            clientId: '17r21a03c5csj0gtno66vqp6q5',
            oauthDomain: 'https://top-legal-prod.auth.eu-central-1.amazoncognito.com',
        },
        addinOrigin: 'https://beta-outlook.top.legal',
    },
    prod: {
        gqlEndpoint: 'https://apollo.top.legal/graphql',
        cognito: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_tgXUQvdgQ',
            clientId: '17r21a03c5csj0gtno66vqp6q5',
            oauthDomain: 'https://top-legal-prod.auth.eu-central-1.amazoncognito.com',
        },
        addinOrigin: 'https://outlook.top.legal',
    },
};
const env = typeof ADDIN_ENV !== 'undefined' ? ADDIN_ENV : 'dev';
/**
 * Auth0 is a single tenant shared by every environment: the backend's verifier
 * (appsync-backend server.ts) pins this issuer for dev, beta, prod and Zurich alike,
 * and dealroom-fe's Auth0Client.ts hardcodes the same pair. Mirrored here rather
 * than made per-env so the three stay in step.
 *
 * The clientId is the web app's on purpose — the backend validates `aud` against a
 * fixed allow-list, so a separate add-in application would be rejected until it is
 * added there. Only the callback URLs differ, and Auth0 allows many per application.
 */
const auth0 = {
    domain: 'dev-3pmt2r3fc7srrklo.eu.auth0.com',
    clientId: '91NzJoifKqcKfb3f0FpSA5t3kOUBXGm7',
};
export const config = {
    ...configs[env],
    env,
    // Backend origin for the non-GraphQL REST routes (the SAML login entry point lives there).
    // Derived the same way dealroom-fe derives BASE_URL, so the two cannot drift apart.
    apiOrigin: configs[env].gqlEndpoint.replace('/graphql', ''),
    auth0,
};
